
<template>
	<div>
		<v-context-menu ref="obj_context_menu">

			<b-dropdown-item><router-link :to="'/analogues/' + analogues_id">Открыть объект-аналог</router-link></b-dropdown-item>

		</v-context-menu>
		<div class="mt-2" id="diff_plot" style="width:100%;height: 600px;" v-resize v-on:resize="refresh"/>

		<div v-if="plot_type != 'Не выбросы'">

			<b-row>

				<b-col cols="6" align="left">Количество ОА со стоимостью ниже рыночной стоимости:</b-col>
				<b-col align="left">{{ data.stats[get_model_name(model)].count_less_than_average[get_plot_type_name(plot_type)] }}</b-col>

			</b-row>

			<b-row class="mt-2">

				<b-col cols="6" align="left">Количество ОА со стоимостью больше рыночной стоимости:</b-col>
				<b-col align="left">{{ data.stats[get_model_name(model)].count_larger_than_average[get_plot_type_name(plot_type)] }}</b-col>

			</b-row>

		</div>
	</div>
</template>

<script>

import api from "../../../../../../api"
import * as d3 from "d3"
import lasso from "../../../../../../third_party/my_d3_lasso/lasso.js"
import { bus } from "../../../../../../api/bus"
import o from "./../objects"

const margin = { top : 24, right : 0, bottom : 36, left : 87 }
const padding = { top : 4 }
const scrollbar = { height : 20, width : 20 }
const legend_width = 200
const height = 600 - margin.top - margin.bottom - scrollbar.height
const colors = [ "var(--bft-blue-500)", "var(--bft-green-400)", "var(--bft-neutral-300)", "var(--bft-neutral-300)" ]

export default
{
	props :
	{
		model : String,
		data : Object,
		initial_plot_type : String,
	},

	data()
	{
		return {

			tab_ready : false,
			plot_type : null,

			k : 1,
			pos_x : 0,
			pos_y : 0,
			coef : 0,

			analogues_id: '',

		}
	},

	watch :
	{
		data :
		{
			immediate : true,
			deep : true,
			handler(data, old_data)
			{
				this.data = data

				if (old_data
					&& (old_data.conf.average_error.teach != this.data.conf.average_error.teach
					|| old_data.conf.average_error.test != this.data.conf.average_error.test))
					this.refresh()
				else
					this.update()
			},
		},

		model :
		{
			immediate : true,
			handler(model)
			{
				this.model = model

				this.refresh()
			},
		},
	},

	mounted()
	{
		this.tab_ready = true

		bus.$on("reset_lasso", this.reset_lasso)
		bus.$on("set_plot_type",
			ev =>
			{
				this.plot_type = ev.plot_type

				this.update()
			})
		o.objects().bus.$on("refresh_plots", () => this.refresh())
		o.objects().bus.$on("update_objects", () => this.update())
		o.objects().bus.$on("update_plots", () => this.update())
	},

	methods :
	{
		get_model_name(rus)
		{
			if(rus == "Линейная")
				return "add"
			else if(rus == "Мультипликативная степенная")
				return "mult"

			return "exp"
		},

		get_plot_type_name(rus)
		{
			if(rus == "Все")
				return "all"
			else if(rus == "Обучающая выборка")
				return "teach"
			else if(rus == "Контрольная выборка")
				return "test"

			return null
		},

		get_model_id(model)
		{
			if(model == "Линейная")
				return "add"

			if(model == "Мультипликативная степенная")
				return "mult"

			return "exp"
		},

		get_environment()
		{
			const id = "#diff_plot"
			var div = d3.select(id)
			var node = div.node()
			const width = ( node == null ? 1000 : node.offsetWidth ) - margin.left - margin.right - scrollbar.width - legend_width
			const env = { id : id, div : div, width : width, height : height }

			if(width > 0)
			{
				this.prev_env = env

				return env
			}
			else if(this.prev_env != null)
				return this.prev_env

			return env
		},

		refresh()
		{
			if(this.svg != null)
			{
				this.svg.remove()
				this.base_div.remove()

				this.svg = null
				this.base_div= null
			}

			if(this.plot_type == null)
				this.plot_type = this.initial_plot_type

			if(this.plot_type == null || this.model == null)
				return

			if(! this.tab_ready)
				return

			const env = this.get_environment()

			if(env.width < 0)
				return

			var base_div_null = false

			if(this.base_div == null)
			{
				base_div_null = true

				this.base_div = env.div.append("div")
					.style("width", ( env.width + margin.left + margin.right + scrollbar.width + legend_width ) + "px")
					.style("height", ( height + margin.top + margin.bottom + scrollbar.height ) + "px")

				this.scrollbar_y_div = this.base_div.append("div")
					.attr("class", "plot_scrollbar")
					.style("width", `${scrollbar.width}px`).style("height", `${height}px`).style("overflow-y", "auto")
					.style("margin-top", `${margin.top}px`)
					.style("float", "left")
					.on("scroll", ev => this.set_position(ev, true))
				this.scrollbar_y = this.scrollbar_y_div.append("div")
					.append("div")
					.style("width", "1px")
					.style("height", `${height}px`)

				this.legend_div = this.base_div.append("div")
					.style("width", `${legend_width}px`).style("height", `${height}px`)
					.style("margin", "0px")
					.style("float", "right")
				this.legend_svg = this.legend_div.append("svg")
					.attr("width", legend_width)
					.attr("height", height + margin.top + margin.bottom)

				this.base_svg = this.base_div.append("svg")
					.attr("width", env.width + margin.left + margin.right)
					.attr("height", height + margin.bottom)
					.attr("transform", "translate( 0, " + margin.top + ")")
				
				this.axisXTitle = this.base_div.append("span")
					.attr("class", "x label")
					.style("position", "absolute")
					.style("top", `${height + margin.top + margin.bottom*0.375}px`)
					.style("right", `${legend_width}px`)
					.style("font-size", "1rem")
					.style("color", "var(--bft-neutral-400)")
					.text("Порядковый номер")
				
				this.axisYTitle = this.base_div.append("span")
					.attr("class", "y label")
					.style("position", "absolute")
					.style("left", 0)
					.style("font-size", "1rem")
					.style("color", "var(--bft-neutral-400)")
					.text("Удельный показатель цены (скорректированный или рассчитанный)")

				this.scrollbar_x_div = this.base_div.append("div")
					.attr("class", "plot_scrollbar")
					.style("width", ( env.width ) + "px").style("height", `${scrollbar.height}px`).style("overflow-x", "auto")
					.style("margin-left", ( margin.left + scrollbar.width ) + "px")
					.style("margin-right", ( margin.right + legend_width ) + "px")
					.style("position", "absolute")
					.style("top", `${height + margin.top + margin.bottom}px`)
					.on("scroll", ev => this.set_position(ev, false))
				this.scrollbar_x = this.scrollbar_x_div.append("div")
					.style("width", `${env.width}px`)
					.style("height", "1px")

				this.legend_svg.append("rect").attr("x", 30 - 8/2).attr("y", env.height / 2 - 94.8 - 20)
					.attr("width", 8)
					.attr("height", 16)
					.attr("rx", 4)
					.style("fill", colors[0])
				this.legend_svg.append("rect").attr("x", 30 - 8/2).attr("y", env.height / 2 - 37 - 20)
					.attr("width", 8)
					.attr("height", 16)
					.attr("rx", 4)
					.style("fill", colors[1])
				this.legend_svg.append("path")
					.attr("class", "cross")
					.attr("d", d3.symbol().type(d3.symbolCross).size(75))
					.attr("transform", `translate(30, ${env.height / 2 - 8.2}) rotate(45)`)
				this.legend_svg.append("rect").attr("x", 30 - 8/2).attr("y", env.height / 2 + 20 )
					.attr("width", 8)
					.attr("height", 16)
					.attr("rx", 4)
					.style("fill", colors[2])

				this.legend_svg.append("text").attr("x", 50).attr("y", env.height / 2 - 115.6).text("Скорректированные удельные показатели цены").style("font-size", "0.75rem").attr("alignment-baseline", "middle").call(this.wrap, 150)
				this.legend_svg.append("text").attr("x", 50).attr("y", env.height / 2 - 57.8).text("Рассчитанные (по модели) удельные показатели цены").style("font-size", "0.75rem").attr("alignment-baseline", "middle").call(this.wrap, 150)
				this.legend_svg.append("text").attr("x", 50).attr("y", env.height / 2 - 7.6).text("Выбросы").style("font-size", "0.75rem").attr("alignment-baseline", "middle")
				this.legend_svg.append("text").attr("x", 50).attr("y", env.height / 2 + 27).text("Границы допустимых значений").style("font-size", "0.75rem").attr("alignment-baseline", "middle").call(this.wrap, 150)
			}

			this.coef = Math.min(this.data.conf.average_error.teach, this.data.conf.average_error.test)

			this.plot_data_predicted_uprs = o.objects().plot_diff(this.model, "predicted_uprs", "uprs")
			this.plot_data_uprs = o.objects().plot_diff(this.model, "uprs")
			this.plot_data_uprs_plus_coef = o.objects().plot_diff(this.model, "uprs", "y", this.coef)
			this.plot_data_uprs_minus_coef = o.objects().plot_diff(this.model, "uprs", "y", - this.coef)
			this.plot_data_lines = [ this.plot_data_uprs, this.plot_data_predicted_uprs, this.plot_data_uprs_plus_coef, this.plot_data_uprs_minus_coef ]

			this.min_x = 0
			this.max_x = o.objects().count
			this.min_x_all = this.min_x
			this.max_x_all = this.max_x

			this.min_y = Math.min(...this.plot_data_uprs_minus_coef.map(obj => obj.y))
			this.max_y = Math.max(...this.plot_data_uprs_plus_coef.map(obj => obj.y))

			this.min_y_all = this.min_y
			this.max_y_all = this.max_y

			if(base_div_null)
			{
				this.x_axis = this.base_svg.append("g")
				this.y_axis = this.base_svg.append("g")
				
				var x_desc = o.objects().add_axis_min_max(this.x_axis, this.min_x, this.max_x, env.width, [ 0, env.width ], env.height + padding.top, true, d3.axisBottom, margin)
				this.x = x_desc.scale
				this.x_d = x_desc.d

				var y_desc = o.objects().add_axis_min_max(this.y_axis, this.min_y, this.max_y, height - padding.top, [ env.height - padding.top, 0 ], padding.top, true, d3.axisLeft, margin)
				this.y = y_desc.scale
				this.y_d = y_desc.d

				this.new_x = this.x
				this.new_y = this.y

				d3.selectAll("g.tick")
					.style("stroke-width", 0.1)
					.style("font-size", 16)
					.style("color", "var(--bft-neutral-400)")
			}

			this.svg = this.base_svg.append("g").attr("transform", `translate(${margin.left}, ${padding.top})`)

			this.scatter_background = this.svg.append("svg").attr("width", env.width).attr("height", height)
			this.scatter = this.scatter_background.append("g").attr("width", env.width).attr("height", height)
			this.zoom = d3.zoom().on("zoom", ev => this.set_zoom(ev)).filter((ev) => ev.shiftKey)

			this.zoom_rect = this.scatter
				.append("rect")
				.attr("width", env.width)
				.attr("height", height)
				.attr("x", margin.left)
				.style("fill", "none")
				.style("pointer-events", "all")
				.call(this.zoom)

			const add_zoom_event = (ev) => {
				if (ev.key == "Shift") { this.zoom_rect.raise() }
			}
			const delete_zoom_event = (ev) => {
				if (ev.key == "Shift") { this.zoom_rect.lower() }
			}

			this.scatter.on("mouseenter", () => {
				window.addEventListener("keydown", add_zoom_event)
				window.addEventListener("keyup", delete_zoom_event)
			})

			this.scatter.on("mouseleave", () => {
				window.removeEventListener("keydown", add_zoom_event)
				window.removeEventListener("keyup", delete_zoom_event)
				this.zoom_rect.lower()
			})

			var line

			this.scatter.selectAll(".line").remove()
			this.scatter.selectAll(".circle_all").remove()
			this.scatter.selectAll(".circle_uprs").remove()

			// Линии

			line = d3.line()
				.x(obj => this.new_x(obj.ind))
				.y(obj => this.new_y(obj.y))
				.curve(d3.curveMonotoneX)

			this.browser = this.scatter.selectAll(".browser").data(this.plot_data_lines).enter()

			this.browser.append("path")
				.attr("class", "line")
				.attr("fill", "none")
				.attr("d", el => line(el))
				.style("stroke", ( d, ind ) => colors[ ind ])
				.style("stroke-width", "2")

			// Точки

			this.scatter.selectAll(".circle_uprs").data(this.plot_data_predicted_uprs).enter().append("circle")
				.attr("class", "circle_uprs")
				.attr("cx", obj => this.new_x(obj.ind))
				.attr("cy", obj => this.new_y(obj.y))
				.attr("r", 6)
				.style("stroke", "#ffffff")
				.on("click", this.point_click)
				.on("mouseover", this.mouse_over)
				.on("mouseout", this.mouse_out)
				.on("contextmenu", this.obj_context_menu)

			this.scatter.selectAll(".circle_all").data(this.plot_data_uprs).enter().append("circle")
				.attr("class", "circle_all")
				.attr("obj_id", obj => obj.id)
				.attr("cx", obj => this.new_x(obj.ind))
				.attr("cy", obj => this.new_y(obj.y))
				.attr("r", 6)
				.style("stroke", "#ffffff")
				.on("click", this.point_click)
				.on("mouseover", this.mouse_over)
				.on("mouseout", this.mouse_out)
				.on("contextmenu", this.obj_context_menu)

			this.add_lasso()
			this.update()
		},

		new_domains()
		{
			var min_x, max_x, min_y, max_y

			this.plot_data_uprs.forEach(
				elem =>
				{
					if(this.plot_type == "Все" || ! o.objects().bad(elem.id))
					{
						if(min_x == null || min_x > elem.ind)
							min_x = elem.ind

						if(max_x == null || max_x < elem.ind)
							max_x = elem.ind
					}
				})

			min_y = Math.min(...this.plot_data_uprs_minus_coef.filter(elem => ( this.plot_type == "Все" || ! o.objects().bad(elem.id) )).map(obj => obj.y))
			max_y = Math.max(...this.plot_data_uprs_plus_coef.filter(elem => ( this.plot_type == "Все" || ! o.objects().bad(elem.id) )).map(obj => obj.y))

			const x_desc = o.objects().new_domain_for_axis_min_max(this.x, min_x, max_x, this.min_x_all, this.max_x_all, this.plot_type == "Все")
			const y_desc = o.objects().new_domain_for_axis_min_max(this.y, min_y, max_y, this.min_y_all, this.max_y_all, this.plot_type == "Все", this.coef)

			this.min_x = x_desc.min
			this.max_x = x_desc.max
			this.x_d = x_desc.d
			this.min_y = y_desc.min
			this.max_y = y_desc.max
			this.y_d = y_desc.d
		},

		set_position(ev, is_y)
		{
			if(is_y)
			{
				const raw_pos = ev.srcElement.scrollTop
				const raw_height = ev.srcElement.scrollHeight
				const pos = raw_pos / raw_height
				const base_coord_0 = this.new_y(this.min_y - this.y_d)
				const distance = this.new_y(this.max_y + this.y_d) - base_coord_0
				const pos_distance = pos * distance

				this.pos_y = pos_distance
				ev.transform = new d3.ZoomTransform(this.k, this.pos_x, this.pos_y)
				this.set_zoom(ev, true)
			}
			else
			{
				const raw_pos = ev.srcElement.scrollLeft
				const raw_width = ev.srcElement.scrollWidth
				const pos = raw_pos / raw_width
				const base_coord_0 = this.new_x(this.min_x - this.x_d)
				const distance = this.new_x(this.max_x + this.x_d) - base_coord_0
				const pos_distance = pos * distance
				
				this.pos_x = - pos_distance
				ev.transform = new d3.ZoomTransform(this.k, this.pos_x, this.pos_y)
				this.set_zoom(ev, true)
			}
		},

		add_lasso()
		{
			if(api.check_roles(this, [ "model"] ))
			{
				const env = this.get_environment()

				this.lasso = lasso()
					.closePathSelect(true)
					.targetArea(this.scatter)
					.items(this.scatter.selectAll("circle"))
					.width(env.width)
					.height(height)
					.on("end", this.lasso_end)
			
				this.svg.call(this.lasso)
			}
		},

		point_click(ev, obj)
		{
			const selection = this.scatter.selectAll("circle").filter(_obj => _obj != null && _obj.id == obj.id && this.scatter.select("circle[obj_id='" + obj.id + "']").style("opacity") != 0)

			o.objects().toggle(selection, ev.ctrlKey)
		},

		mouse_over(ev, obj)
		{
			const env = this.get_environment()
			var coord = d3.pointer(ev)
			var message = `Скорректированный удельный показатель цены: ${api.round2(obj.uprs)}`

			if(obj.predicted_uprs != null)
				message += `<br/>Рассчитанный (по модели) удельный показатель цены: ${api.round2(obj.predicted_uprs)}<br/>Невязка: ${api.round2(obj.diff)}`

			if(this.tooltip)
			{
				this.tooltip.remove()
				this.tooltip = null
			}

			var elem = this.scatter.select("circle[obj_id='" + obj.id + "']")

			if(elem.style("opacity") == 0)
				return

			this.tooltip = d3.select(env.id).append("div")
				.attr("class", "tooltip")
				.style("opacity", 1)
				.html(message)
				.style("left", ( coord[0] + 30 ) + "px")
				.style("top", ( coord[1] + 30 ) + "px")
		},

		mouse_out()
		{
			if(this.tooltip)
				this.tooltip.remove()
		},

		set_zoom(ev, set_position = false)
		{
			if(set_position)
			{
				if(ev.transform.x == null)
					ev.transform.x = 0

				if(ev.transform.y == null)
					ev.transform.y = 0

				this.pos_x = ev.transform.x
				this.pos_y = ev.transform.y
			}
			else
			{
				if(ev.sourceEvent.type != "wheel")
					return

				if(ev.sourceEvent.wheelDelta > 0)
					ev.transform.k += 0.001
				else
					ev.transform.k -= 0.001

				if(ev.transform.k < 1)
				{
					ev.transform.k = 1
					ev.transform.x = 0
					ev.transform.y = 0

					this.new_domains()
				}

				this.k = ev.transform.k
			}

			const env = this.get_environment()
			this.new_x = ev.transform.rescaleX(this.x).interpolate(d3.interpolateRound)
			this.new_y = ev.transform.rescaleY(this.y).interpolate(d3.interpolateRound)

			this.x_axis
				.call(d3.axisBottom(this.new_x).ticks(10).tickFormat(value => api.number_to_string_with_ranking(value)).tickSize(-height))
				.call(g => g.selectAll(".domain").remove())

			if(! set_position)
			{
				const from = this.new_x(this.min_x - this.x_d)
				const to = this.new_x(this.max_x + this.x_d)
				const diff = Math.abs(to - from)
				const new_width = Math.max(diff, env.width)
				const mouse = ev.sourceEvent.offsetX - margin.left
				const mouse_prepared = this.new_x.invert(mouse)
				const coef = mouse_prepared / ( this.max_x - this.min_x )
				const pos = new_width * coef

				this.scrollbar_x_div.property("scrollLeft", pos)
				this.scrollbar_x.style("width", `${new_width}px`)
			}

			this.y_axis
				.call(d3.axisLeft(this.new_y).ticks(10).tickFormat(value => api.number_to_string_with_ranking(value)).tickSize(-env.width))
				.call(g => g.selectAll(".domain").remove())

			if(! set_position)
			{
				const from = this.new_y(this.min_y - this.y_d)
				const to = this.new_y(this.max_y + this.y_d)
				const diff = Math.abs(to - from)
				const new_height = Math.max(diff, height)
				const mouse = ev.sourceEvent.offsetY
				const mouse_prepared = this.new_y.invert(mouse)
				const coef = 1 - mouse_prepared / this.max_y
				const pos = new_height * coef

				this.scrollbar_y_div.property("scrollTop", pos)
				this.scrollbar_y.style("height", `${new_height}px`)
			}
			
			this.scatter.selectAll(".circle_all")
				.attr("cx", obj => this.new_x(obj.ind))
				.attr("cy", obj => this.new_y(obj.uprs))
			this.scatter.selectAll(".circle_uprs")
				.attr("cx", obj => this.new_x(obj.ind))
				.attr("cy", obj => this.new_y(obj.predicted_uprs))
			this.scatter_background.selectAll(".cross")
				.attr("transform", obj => this.bad_symbol_transform(obj.ind, obj.y))
			this.scatter_background.selectAll(".cross_predicted")
				.attr("transform", obj => this.bad_symbol_transform(obj.ind, obj.predicted_uprs))

			d3.selectAll("g.tick")
				.style("stroke-width", 0.1)
				.style("font-size", 16)
				.style("color", "var(--bft-neutral-400)")

			var new_line = d3.line()
				.x(obj => this.new_x(obj.ind))
				.y(obj => this.new_y(obj.y))
				.curve(d3.curveMonotoneX)
			
			var plot_data_lines_filtered = []

			this.plot_data_lines.forEach(
				( plot_data, ind ) =>
					plot_data_lines_filtered.push(
						plot_data
							.filter(
								obj =>
								{
									var result = false
									const bad = o.objects().bad(obj.id)

									if(this.plot_type == "Все" && ind != 1)
										result = true
									else if(this.plot_type == "Обучающая выборка")
										result = (obj.is_teach && ! bad)
									else if(this.plot_type == "Контрольная выборка")
										result = (obj.is_test && ! bad)
									else
										result = (! bad)

									return result
								})
							)
						)

			this.browser.selectAll(".line")
				.attr("class", "line")
				.attr("fill", "none")
				.attr("d", ( el, ind ) => new_line(plot_data_lines_filtered[ind]))
				.style("stroke", ( d, ind ) => colors[ ind ])
				.style("stroke-width", "2")
		},

		bad_symbol_transform(x, y)
		{
			const _x = this.new_x(x)
			const _y = this.new_y(y)

			return `translate(${_x}, ${_y}) rotate(45)`
		},

		update()
		{
			if(this.scatter)
			{
				var points = this.scatter.selectAll("circle").filter(obj => obj != null)

				if(this.plot_type == "Все")
				{
					points.filter(obj => o.objects().bad(obj.id)).style("opacity", "1%")
					points.filter(obj => ! o.objects().bad(obj.id)).style("opacity", "100%").raise()
				}
				else if(this.plot_type == "Обучающая выборка")
				{
					points.filter(obj => obj.is_teach).style("opacity", "100%").raise()
					points.filter(obj => ! obj.is_teach || o.objects().bad(obj.id)).style("opacity", "0%")
				}
				else if(this.plot_type == "Контрольная выборка")
				{
					points.filter(obj => ! obj.is_teach).style("opacity", "100%").raise()
					points.filter(obj => obj.is_teach || o.objects().bad(obj.id)).style("opacity", "0%")
				}
				else
				{
					// Не выбросы
					points.filter(obj => o.objects().bad(obj.id)).style("opacity", "0%")
					points.filter(obj => ! o.objects().bad(obj.id)).style("opacity", "100%").raise()
				}

				this.scatter.selectAll(".circle_all").style("fill", obj => o.objects().color(obj.id))
				this.scatter.selectAll(".circle_uprs").style("fill", obj => o.objects().selected(obj.id) ? colors[2] : colors[1])
				this.scatter.selectAll(".circle_uprs").filter(obj => obj != null && o.objects().bad(obj.id)).style("opacity", "0%")

				if(this.plot_type == "Все")
				{
					var plot_data_crosses = this.plot_data_uprs.filter(obj => o.objects().bad(obj.id))
					const bad_symbol = d3.symbol().type(d3.symbolCross).size(75)

					var crosses = this.scatter.append("g").attr("class", "crosses")

					crosses.selectAll(".cross").data(plot_data_crosses).enter()
						.append("path")
						.attr("class", "cross")
						.attr("d", bad_symbol)
						.style("fill", obj => o.objects().selected(obj.id) ? colors[2] : "var(--bft-natural-900)")
						.attr("transform", obj => this.bad_symbol_transform(obj.ind, obj.y))

					var crosses_predicted = this.scatter.append("g").attr("class", "crosses_predicted")

					crosses_predicted.selectAll(".cross_predicted").data(plot_data_crosses).enter()
						.append("path")
						.attr("class", "cross_predicted")
						.attr("d", bad_symbol)
						.style("fill", obj => o.objects().selected(obj.id) ? colors[2] : colors[1])
						.attr("transform", obj => this.bad_symbol_transform(obj.ind, obj.predicted_uprs))
					
					points.raise()
				}
				else
				{
					this.scatter.selectAll(".crosses").remove()
					this.scatter.selectAll(".crosses_predicted").remove()
				}

				var new_line = d3.line()
					.x(obj => this.new_x(obj.ind))
					.y(obj => this.new_y(obj.y))
					.curve(d3.curveMonotoneX)
				var plot_data_lines_filtered = []

				this.plot_data_lines.forEach(
					( plot_data, ind ) =>
						plot_data_lines_filtered.push(
							plot_data
								.filter(
									obj =>
									{
										var result = false
										const bad = o.objects().bad(obj.id)

										if(this.plot_type == "Все" && ind != 1)
											result = true
										else if(this.plot_type == "Обучающая выборка")
											result = (obj.is_teach && ! bad)
										else if(this.plot_type == "Контрольная выборка")
											result = (obj.is_test && ! bad)
										else
											result = (! bad)

										return result
									})
								)
							)

				this.browser.selectAll(".line")
					.attr("class", "line")
					.attr("fill", "none")
					.attr("d", ( el, ind ) => new_line(plot_data_lines_filtered[ind]))
					.style("stroke", ( d, ind ) => colors[ ind ])
					.style("stroke-width", "2")

				if(this.k < 1.00001)
				{
					this.new_domains()

					this.pos_x = 0
					this.pos_y = 0

					var ev = { sourceEvent : { offsetX : 0, offsetY : 0 } }
					ev.transform = new d3.ZoomTransform(this.k, this.pos_x, this.pos_y)

					this.set_zoom(ev, true)
				}
			}
		},

		lasso_end(ev)
		{
			const selection = this.lasso.selectedItems().filter(
				_obj =>
				{
					if(_obj)
					{
						const elem = this.scatter.select("circle[obj_id='" + _obj.id + "']")

						return elem.style("opacity") != 0
					}

					return false
				})

			o.objects().toggle(selection, ev.sourceEvent.ctrlKey)
        },

		reset_lasso()
		{
			if(this.svg)
			{
				this.svg.selectAll(".lasso").remove()
				this.add_lasso()
			}
		},

		obj_context_menu(ev)
		{
			this.analogues_id = ev.target.__data__.id
			ev.preventDefault()
			this.$refs.obj_context_menu.open(ev)
		},

		wrap(text, width)
		{
			text.each(function () {
				var text = d3.select(this),
					words = text.text().split(/\s+/).reverse(),
					word,
					line = [],
					lineNumber = 0,
					lineHeight = 1.1, // ems
					x = text.attr("x"),
					y = text.attr("y"),
					dy = 0, //parseFloat(text.attr("dy")),
					tspan = text.text(null)
								.append("tspan")
								.attr("x", x)
								.attr("y", y)
								.attr("dy", dy + "em");
				word = words.pop()
				while (word) {
					line.push(word);
					tspan.text(line.join(" "));
					if (tspan.node().getComputedTextLength() > width) {
						line.pop();
						tspan.text(line.join(" "));
						line = [word];
						tspan = text.append("tspan")
									.attr("x", x)
									.attr("y", y)
									.attr("dy", ++lineNumber * lineHeight + dy + "em")
									.text(word);
					}
					word = words.pop()
				}
			});
		},
	}
}

</script>

<style>

#diff_plot .tooltip
{
	background-color : var(--bft-neutral-900-tooltip);
	box-shadow: 0 10px 15px 0 var(--bft-neutral-500-tooltip) !important;
    border-radius : .25rem;
	color: #ffffff;
	opacity: 0;
	padding: .25rem .5rem;
	font-family: inherit;
}

#diff_plot:hover .plot_scrollbar::-webkit-scrollbar-thumb
{
	background-color: var(--bft-neutral-300) !important;
}
@-moz-document url-prefix() {
	#diff_plot:hover .plot_scrollbar
	{
		scrollbar-color: var(--bft-neutral-300) transparent;
	}
}

.lasso path
{
	stroke: rgb(80,80,80);
    stroke-width: 2px;
}

.lasso .drawn
{
	fill-opacity: 0.05;
}

.lasso .loop_close
{
	fill: none;
	stroke-dasharray: 4, 4;
}

.lasso .origin
{
	fill: rgb(51, 153, 255);
	fill-opacity: 0.5;
}

</style>


